
import Tab from './Tab';
import Tabs from './Tabs';
import TabsProps, { TabProps, TabsType, TabsDirection, TabsSize } from './PropsType';

Tabs.Tab = Tab;

export default Tabs;
export { TabsProps, TabProps, TabsType, TabsDirection, TabsSize };
